var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFish = function SvgFish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M11.8 3.555c-3.173.016-6.3 1.619-7.362 3.8A1.45 1.45 0 0 0 4.757 9L7.3 11.541"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M9.88 17.267c8.571-1.513 14.234-5.933 13.262-15.125A1.46 1.46 0 0 0 21.858.858C12.666-.114 8.246 5.548 6.733 14.12L1.16 16.6a.742.742 0 0 0 .1 1.367l3.9.87.87 3.9a.743.743 0 0 0 1.367.1z"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M20.445 12.2c-.016 3.173-1.619 6.3-3.8 7.362A1.45 1.45 0 0 1 15 19.243L12.462 16.7m-5.729-2.58 3.147 3.147"
  })), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M16.875 5.25a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
  }))));
};
export default SvgFish;